module.exports = __webpack_public_path__ + "img/card_2.77252d16.jpeg";